export const _SitemapCc = {
    url: 'contaContabil',
    descricao: 'Contas contábeis',
    nome: 'Contas contábeis',
    permissao: ['VisualizarContasContabeis'],
    fullUrl: '/contaContabil/menu',
    children:
        {
            ['menu']: {
                url: 'menu',
                descricao: 'Menu de contas contábeis',
                nome: 'Menu de contas contábeis',
                permissao: ['VisualizarContasContabeis'],
                fullUrl: '/contaContabil/menu',
            },
            ['valoresDistribuiveis']: {
                url: 'valoresDistribuiveis',
                descricao: 'Valores distribuíveis',
                nome: 'Valores distribuíveis',
                permissao: ['VisualizarContasContabeis'],
                fullUrl: '/contaContabil/valoresDistribuiveis/lista',
                children: {
                    ['lista']: {
                        url: 'lista',
                        descricao: 'Lista de valores distribuíveis',
                        nome: 'Lista de valores distribuíveis',
                        permissao: ['VisualizarContasContabeis'],
                        fullUrl: '/contaContabil/valoresDistribuiveis/lista',
                    },
                    ['detalhes']: {
                        url: 'detalhes',
                        descricao: 'Detalhes do valor distribuível',
                        nome: 'Detalhes do valor distribuível',
                        permissao: ['VisualizarContasContabeis'],
                        fullUrl: '/contaContabil/valoresDistribuiveis/detalhes',
                    }
                }
            }
        },
} as const